import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
export const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const token = useAuthStore((state) => state.token);
    const tenant = useAuthStore((state) => state.tenant);
    if (!isAuthenticated || !token) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    if (tenant?.mustChangePassword && location.pathname !== '/change-password') {
        return _jsx(Navigate, { to: "/change-password", replace: true });
    }
    if (tenant?.mustSetupTwoFactor && location.pathname !== '/two-factor-setup') {
        return _jsx(Navigate, { to: "/two-factor-setup", replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
